import React from "react";
import line from "../Assets/catalog-line-img.svg";
import "./Catalog.css";
import Rajasthani from "../Assets/14 (1) (1).jpg";
import Desi from "../Assets/15 (1) (1) (1).jpg";
import AntiqueGold from "../Assets/22 (1).jpg";
import silver from "../Assets/calalog-img4.jpg";
import { Link } from "react-router-dom";

const Catalog = () => {
  return (
    <>
      <div className="catalog-page">
        <div className="">
          <div className="data-section">
            <div className="heading">
              <h2 className="cata-heading font-bold text-xl">Shop by Catalog</h2>
            </div>
            <div className="para">
              <p className="para-text">
                First-class jewelry for first-class Men, Women & Children.
              </p>
            </div>
            <img src={line} alt="line" />
          </div>
          <div className="catalog-img-container">
            <div className="Rajasthani-catalog">
              <div className="gender-dev">
                <div className="Rajasthani-img">
                  <img className="Img" src={Rajasthani} alt="Rajasthani" />
                </div>
                <div className="info-div">
                  <h6 className="cata_text">Rajasthani</h6>
                  <Link to='/rajasthanigallery' className="explore-more">
                    <span>Explore More </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="AntiqueGold-catalog">
              <div className="gender-dev Antique_dev">
                <div className="Antique-Gold-img">
                  <img className="Img AntiqueGold" src={AntiqueGold} alt="Antique-Gold" />
                </div>
                <div className="info-div">
                  <h6 className="cata_text">Antique Gold</h6>
                  <Link to="/AntiqueGoldGallery" className="explore-more">
                    <span>Explore More </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="Marwadi-catalog">
              <div className="gender-dev Marwadi-dev">
                <div className="Desi-img">
                  <img className="Img" src={Desi} alt="Desi" />
                </div>
                <div className="info-div">
                  <h6 className="cata_text">Marwadi</h6>
                  <Link to="/DesiGallery" className="explore-more">
                    <span>Explore More </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="silver-catalog">
              <div className="gender-dev silver-dev">
                <div className="silver-img">
                  <img className="Img" src={silver} alt="silver" />
                </div>
                <div className="info-div">
                  <h6 className="cata_text">Silver</h6>
                  <Link to="/SilverGallery" className="explore-more">
                    <span>Explore More </span>
                  </Link>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default Catalog;
